<template>
  <div class="user expostat-event" v-if="currentBrand">
    <!--<div class="photo">-->
    <!--<gravatar email="$auth.user().email" />-->
    <!--&lt;!&ndash;<img src="static/img/faces/face-2.jpg"/>&ndash;&gt;-->
    <!--</div>-->
    <div class="info">
      <span class="title" v-translate>Event:</span>
      <a data-toggle="collapse" class="current" :aria-expanded="!isClosed" @click="isClosed = !isClosed" href="javascript:void(0)">
             <span>
               <span v-if="currentEventInfo">{{ currentEventInfo.name }}</span>
               <span v-else v-translate>Select event...</span>
               <b class="caret"></b>
            </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav nav-menu" v-show="!isClosed">
            <li v-for="event in available">
              <a href="javascript:void(0)" @click="selectEvent(event)">
                <!--<span class="sidebar-mini-icon fa fa-lock"></span>-->
                <span class="sidebar-normal">{{ event.name }}</span>
              </a>
            </li>
          </ul>
        </collapse-transition>
      </div>
    </div>
  </div>
</template>

<script>
  import { CollapseTransition } from 'vue2-transitions'
  import store from 'src/store'
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'



  export default {
    computed: {
      ...mapState({
        currentBrand: state => state.brands.current,
        available: state => state.events.available,
        currentEventInfo: state => state.events.currentEventInfo
      }),
      // ...mapGetters({currentEventInfo: 'events/currentEventInfo'})
    },
    mounted () {
      store.dispatch('events/update')
    },
    components: {
      CollapseTransition
    },
    data () {
      return {
        isClosed: true
      }
    },
    methods: {
      selectEvent (event) {
        store.dispatch('events/changeCurrent', event.id)
        this.isClosed = true
      },
    },
    name: 'EventSelector'
  }
</script>

<style scoped lang="scss">
  .expostat-event {
    .title {
      padding: 0px 25px;
      color: $medium-gray;
    }

    .current {
      white-space: normal !important;
    }

    span.sidebar-normal {
      white-space: normal;
    }
  }
  .sidebar .nav li > a, .off-canvas-sidebar .nav li > a {
    margin: 0;
    padding: 5px 8px;
  }
  .sidebar .sidebar-wrapper .expostat-event .info [data-toggle="collapse"] ~ div > ul > li > a .sidebar-normal {
    white-space: normal;
  }
</style>
